import React from 'react'
import { Field } from 'redux-form'
import MediaUpload from './MediaUpload'

export default function WhatsAppMediaUpload() {

  return (
    <div className='pl-4 position-relative'>
      <Field
        name="whatsapp_media_attributes"
        component={MediaUpload}
        imageClasses="img-fluid"
        labelClasses="d-block"
        wrapperClasses=""
      />
    </div>
  )
}
